import type { LngLat, PlaceMatch } from '@chukua/common';
import { Form } from 'antd';
import { LocationPickerField } from '../../zones/public/LocationPickerField';

interface CompanyLocationFieldProps {
  /** From the Form.Item it sits in. */
  value?: LngLat | null;
  onChange?: (location: LngLat | null) => void;
}

/**
 * Where the company is (its head office or main yard), shown on the Zones map: found by name, then fine-tuned
 * by clicking the map or dragging the pin. A picked place also fills in the address while that is still empty.
 */
export function CompanyLocationField({ value = null, onChange }: CompanyLocationFieldProps) {
  const form = Form.useFormInstance();

  function onPlacePicked(place: PlaceMatch) {
    if (!form.getFieldValue('address')) form.setFieldsValue({ address: [place.name, place.context].filter(Boolean).join(', ') });
  }

  return (
    <LocationPickerField
      value={value}
      onChange={(location) => onChange?.(location)}
      onPlacePicked={onPlacePicked}
      searchAriaLabel="Find the company's location"
      searchPlaceholder="Office, yard or town"
      emptyCaption="Head office or main yard: the Zones map marks it and opens on it. Find it by name, or click the map."
    />
  );
}
